import { createFileRoute } from '@tanstack/react-router'

import { useAuth } from '@/auth/use-auth'
import { ExpenseReport } from '@/components/expenses/expense-report'
import { parseExpensesSearch } from '@/components/expenses/expenses-search-schema'
import { ExpensesWorkspace } from '@/components/expenses/expenses-workspace'
import { Frame } from '@/components/frame'
import { PageHeader } from '@/components/page-header'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

/**
 * Notes de frais (lot 15, #212) : la liste, filtres dans l'URL, tableau dans
 * son cadre ; et pour l'administrateur l'onglet « À rembourser », le rapport
 * du serveur avec l'export CSV.
 */
export const Route = createFileRoute('/_app/frais/')({
  validateSearch: parseExpensesSearch,
  component: ExpensesPage,
})

function ExpensesPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const { isAdmin } = useAuth()
  const onSearchChange = (next: Partial<typeof search>) => {
    void navigate({ search: (current) => ({ ...current, ...next }) })
  }

  if (!isAdmin) {
    return (
      <div className="space-y-6">
        <PageHeader title="Notes de frais" documentTitle="Notes de frais" />
        <Frame>
          <ExpensesWorkspace search={search} onSearchChange={onSearchChange} />
        </Frame>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <PageHeader title="Notes de frais" documentTitle="Notes de frais" />
      <Tabs
        value={search.onglet ?? 'notes'}
        onValueChange={(value) => {
          void navigate({
            search: (current) => ({
              ...current,
              onglet: value === 'a-rembourser' ? 'a-rembourser' : undefined,
              page: 1,
            }),
          })
        }}
      >
        <TabsList>
          <TabsTrigger value="notes">Notes</TabsTrigger>
          <TabsTrigger value="a-rembourser" data-testid="frais-onglet-rapport">
            À rembourser
          </TabsTrigger>
        </TabsList>
        <TabsContent value="notes">
          <Frame>
            <ExpensesWorkspace search={search} onSearchChange={onSearchChange} />
          </Frame>
        </TabsContent>
        <TabsContent value="a-rembourser">
          <Frame>
            <ExpenseReport search={search} onSearchChange={onSearchChange} />
          </Frame>
        </TabsContent>
      </Tabs>
    </div>
  )
}
